<template>
	<div class="sm_star" v-if="showPopup">
		<div class="mdc-dialog" data-mdc-auto-init="MDCDialog" style="display: block; z-index:999;" v-if="popupData">
			<div class="attched-close-button" id="attched-close-button" style="z-index:999;" v-if="close">
				<img src="/images/close-button.svg" alt="" @click="hideImage" @keypress="hideImage" class="cursor-pointer w-48 h-48 attched-close-button" tabindex="0">
			</div>
			<div class="mdc-dialog__container" style="opacity:1; transform: scale(1);">
				<div class="container container--narrow">
					<div class="mdc-dialog__surface home-modal" role="alertdialog" aria-modal="true" aria-labelledby="my-dialog-title"
							aria-describedby="my-dialog-content" >
					<div class="bg-white" @click="goToDynamicLink(popupData[0].dynamicLink.shortLink)" @keypress="goToDynamicLink(popupData[0].dynamicLink.shortLink)"><img class="modal-image" :src="popupData[0].image.resourceUri" :alt="popupData[0].image.name"/></div>
					<div class="mdc-dialog__actions bg-white modal-action">
								<button type="button" class="mdc-button mdc-dialog__button" @click="hideImage" @keypress="hideImage" tabindex="0">
									<div class="mdc-button__ripple"></div>
									<span class="mdc-button__label t-color-secondaryBtnText font-m">{{$t('3301')}}</span>
								</button>
							</div>
					</div>
					</div>
				</div>
			<div class="mdc-dialog__scrim" style="opacity:1;" @click="hideImage"  @keypress="hideImage" tabindex="0"></div>
		</div>
		<!-- //content -->
	</div>
</template>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../../mixins/topAppBar.js'
import popupApi from '@/api/popupApi.js'
export default {
    name: 'Main',
    data() {
					return {
						popupData: null,
						close:true
					}
    },
    props:['showPopup'],
    components: {
					TopAppBar,
    },
    mixins: [topAppBarMixin],
    mounted() {
					this.setTopAppBarClosePopup(this.$t('1890'))
					this.$showLoading()
						// get learn basic information
					popupApi.fetpopupDetail().then((response) => {
						this.popupData = response.data.data;
						this.$hideLoading()
					}).catch((err) => {
						responseData = err.response.data.meta
						this.$error({content: responseData.errMsg}).then(() => {})
					})
					if(this.$route.name === 'Main'){
						this.close = false
					}

    },
			methods:{
				hideImage(){
					this.$router.push('/home')
				},

        /**
         *
         * @param {string} link 다이내믹 링크
         */
        goToDynamicLink(link) {
          if(link) {
            const dynamicLinkPath = `${link}?linkType=INTERNAL_LINK`;
            window.location = dynamicLinkPath;
          }
        }
			}
}
</script>
